export const tabs = [
    {
        path: "/occasionalsalarycalendar",
        className: "occasionalsalarycalendar",
        label: "Alkalmi naptár"
    },
    {
        path: "/occasionalsalary",
        className: "occasionalsalary",
        label: "Alkalmi fizetések"
    }

];